var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentsAlt10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.7739C7 11.2091 7.44772 10.7513 8 10.7513H16C16.5523 10.7513 17 11.2091 17 11.7739V21.9999H14V17.9095C14 17.3447 13.5523 16.8869 13 16.8869H11C10.4477 16.8869 10 17.3447 10 17.9095V21.9999H7V11.7739ZM10 13.0521C9.58579 13.0521 9.25 13.3955 9.25 13.8191C9.25 14.2426 9.58579 14.586 10 14.586H14C14.4142 14.586 14.75 14.2426 14.75 13.8191C14.75 13.3955 14.4142 13.0521 14 13.0521H10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64888 4.36689C2.25857 4.51657 2 4.89812 2 5.32439V19.9548C2 21.0843 2.89543 22 4 22H5.5V11.774C5.5 10.362 6.61929 9.21746 8 9.21746H10V3.02353C10 2.30954 9.30263 1.81534 8.64888 2.06604L2.64888 4.36689Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22V11.774C18.5 10.362 17.3807 9.21746 16 9.21746H14V5.32439C14 4.89812 14.2586 4.51657 14.6489 4.36689L20.6489 2.06604C21.3026 1.81534 22 2.30954 22 3.02353V19.9548C22 21.0843 21.1046 22 20 22H18.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentsAlt10);
export default __webpack_public_path__ + "static/media/apartments-alt-10.ab8b41a5ea72f6bc68a4babe763bb61c.svg";
export { ForwardRef as ReactComponent };